module.exports = __webpack_public_path__ + "img/brmja.8d459a61.svg";